import { Injectable } from '@angular/core';
import { ClientTokenRequest } from '../model/client-token';
import { CheckOutRequest } from '../model/checkout-request';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, timeout } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OneincPaymentService {
    static CHANNELID = 'channelId';
    static TIMEOUT = 120000;

    constructor(private http: HttpClient) {}

    getClientToken(requestObject: any, channelId: string) {
        const url: string = environment.backend + environment.uri.clientToken;
        const headers = {};
        headers[OneincPaymentService.CHANNELID] = channelId;

        return this.http
            .post<any>(url, requestObject, {
                headers: new HttpHeaders(headers),
            })
            .pipe(
                timeout(OneincPaymentService.TIMEOUT),
                catchError((error: Response) => {
                    return observableThrowError(error);
                })
            );
    }

    getSessionId(requestObject: CheckOutRequest, channelId: string) {
        const url: string = environment.backend + environment.uri.checkout;
        const headers = {};
        headers[OneincPaymentService.CHANNELID] = channelId;

        return this.http
            .post<any>(url, requestObject, {
                headers: new HttpHeaders(headers),
            })
            .pipe(
                timeout(OneincPaymentService.TIMEOUT),
                catchError((error: Response) => {
                    return observableThrowError(error);
                })
            );
    }

    downloadPaymentReceipt(transactionId: string, channelId: string) {
        let url: string = environment.backend + environment.uri.getReceipt;
        url = url.replace('$transactionId$', transactionId);
        const headers = {};
        headers[OneincPaymentService.CHANNELID] = channelId;

        return this.http
            .post<any>(url, null, {
                headers: new HttpHeaders(headers),
            })
            .pipe(
                timeout(OneincPaymentService.TIMEOUT),
                catchError((error: Response) => {
                    return observableThrowError(error);
                })
            );
    }
}
